import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

import { IVideoModel } from "../video-player/video-player";

interface IDocInfo {
    contentType: string;
    extraClasses: string;
    fileUrlIncluded: boolean;
    key: string;
    title: string;
}

@Component
export default class HelpIndex extends Vue {

    videoModel: IVideoModel;
    showVideo: boolean = false;

    mounted() {


        const treeData = [
            {
                isFolder: true,
                isExpanded: false,
                title: "Reference Manual",
                key: "1 Overview and Purpose.htm",
                extraClasses: "directoryfolder-node",
                children:
                    [
                        { title: "1. Overview and Purpose", key: "1 Overview and Purpose.htm", extraClasses: "document-node" },
                        { title: "2. How a model is structured and works", key: "2 How.htm", extraClasses: "document-node" },
                        { title: "3. Palette of available nodes", key: "3 Palette of Nodes.htm", extraClasses: "document-node" },
                        { title: "4. Demand Node", key: "4 Demand Node.htm", extraClasses: "document-node" },
                        { title: "5. Depletable Resource Node", key: "5 Depletable Resource Node.htm", extraClasses: "document-node" },
                        { title: "6. Resource Node/Economic Node Data", key: "6 Resource Economic Node Data.htm", extraClasses: "document-node" },
                        { title: "7. Conversion and Transportation Process", key: "7 Conversion and Transport.htm", extraClasses: "document-node" },
                        { title: "8. Joint Output (Refinery) Nodes", key: "8 Joint Output Nodes.htm", extraClasses: "document-node" },
                        { title: "9. Electricity Node", key: "9 Electric Nodes.htm", extraClasses: "document-node" },
                        { title: "10. External Price Node", key: "10 External Price Node.htm", extraClasses: "document-node" },
                        { title: "11. Hub and Annual Clearing Hub Nodes", key: "11 Hub and Annual Clearing Nodes.htm", extraClasses: "document-node" },
                        { title: "12. Simple Supply Node", key: "12 Simple Supply Node.htm", extraClasses: "document-node" },
                        { title: "13. Storage Node", key: "13 Storage Node.htm", extraClasses: "document-node" },
                        { title: "14. Upper Bound Node", key: "14 Upper Bound Node.htm", extraClasses: "document-node" },
                        { title: "15. Link Splitter Node", key: "15 Link Splitter Node.htm", extraClasses: "document-node" },
                        { title: "16. Discrete Choice Node", key: "16 Discrete Choice Node.htm", extraClasses: "document-node" },
                        { title: "Footnotes", key: "Footnotes.htm", extraClasses: "document-node" }
                    ]

            },
            {
                isFolder: true,
                isExpanded: false,
                title: "Crude Markets and Market Power",
                key: "CrudeMarketsAndMarketPower1.htm",
                extraClasses: "directoryfolder-node",
                children:
                    [
                        { title: "1. History of OPEC and Oil Modeling", key: "CrudeMarketsAndMarketPower1.htm", extraClasses: "document-node" },
                        { title: "2. History of Monopoly Modeling", key: "CrudeMarketsAndMarketPower2.htm", extraClasses: "document-node" },
                        { title: "3. Technical Discussion of Stackelberg/OPEC", key: "CrudeMarketsAndMarketPower3.htm", extraClasses: "document-node" },
                        { title: "4. Formulating and Solving Stackelberg", key: "CrudeMarketsAndMarketPower4.htm", extraClasses: "document-node" },
                        { title: "5. Extension to the Nash Cournot Duopoly", key: "CrudeMarketsAndMarketPower5.htm", extraClasses: "document-node" },
                        { title: "6. Duopoly in World Crude Markets", key: "CrudeMarketsAndMarketPower6.htm", extraClasses: "document-node" }
                    ]
            },
            {
                isFolder: true,
                isExpanded: false,
                title: "User Interface Manual",
                key: "UI 1. Overview.htm",
                extraClasses: "directoryfolder-node",
                children:
                    [
                        { title: "1. Overview", key: "UI 1. Overview.htm", extraClasses: "document-node" },
                        {
                            title: "2. Creating and Manipulating a Model",
                            key: "UI 2. Creating and Manipulating a Model.htm", extraClasses: "document-node"
                        },
                        { title: "3. Cutting, Copying and Pasting", key: "UI 3. Cutting, Copying and Pasting.htm", extraClasses: "document-node" },
                        { title: "4. Editing Data", key: "UI 4. Editing Data.htm", extraClasses: "document-node" },
                        { title: "5. Generating Reports", key: "UI 5. Generating Reports.htm", extraClasses: "document-node" }
                    ]
            },
            {
                isFolder: true,
                isExpanded: false,
                title: "Instructional Videos",
                extraClasses: "directoryfolder-node",
                key: "",
                children:
                    [
                        {
                            title: "Training Example 1",
                            key: "Dale Nesbitt's WebEx Meeting-20150811 2056-1.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 2",
                            key: "Training Session 2-20150812 2109-1.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 3",
                            key: "Training Example 3-20150812 2228-1.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 4",
                            key: "Training Example 4-20150812 2350-1.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 5",
                            key: "Training Session 5-20150814 2303-2.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 6",
                            key: "Training Session 6-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 7",
                            key: "Training Session 7-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 8",
                            key: "Training Session 8-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Example 9",
                            key: "Training Session 9-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Examples 10 and 11",
                            key: "Training Session 10 and 11-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Examples 12",
                            key: "Training Session 12-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        },
                        {
                            title: "Training Examples 13",
                            key: "Training Session 13-20150814 2339-3.mp4",
                            contentType: "video",
                            extraClasses: "video-node"
                        }
                    ]
            },
            {
                isFolder: true,
                isExpanded: false,
                title: "Presentations",
                key: "/help/PresentationsDocList",
                extraClasses: "directoryfolder-node",
            },
            {
                isFolder: true,
                isExpanded: false,
                title: "Site Update Notifications",
                key: "/help/SiteUpdateNotificationDocList",
                extraClasses: "directoryfolder-node",
                contentType: "pdfFileList"
                //[
                //    {
                //        title: "All updates",
                //        key: "SiteUpdateNotificationDocs",
                //        contentType: "siteUpdateDocsList"
                //    }
                //]
            },
            {
                isFolder: true,
                isExpanded: false,
                title: "OData",
                key: "/help/ODataDocs",
                extraClasses: "directoryfolder-node",
                children:
                    [
                    ]
            },
            {
                isFolder: true,
                isExpanded: false,
                title: "API",
                key: "/help/APIDocs",
                extraClasses: "directoryfolder-node",
                children:
                    [
                    ]
            },



        ];

        let sortedTreeData = treeData.sort((a, b) => a.title.localeCompare(b.title));

        this.populateTree(sortedTreeData);

        var tree = $("#treeDiv").fancytree("getTree");

        var siteUpdatesNode = tree.getNodeByKey("/help/SiteUpdateNotificationDocList");
        this.getChildTreeNodes(siteUpdatesNode.key)
            .then((data: IDocInfo[]) => {

                const sortedData = data.sort((a, b) => a.title.localeCompare(b.title));

                siteUpdatesNode.addChildren(sortedData);
            });

        var presentationsNode = tree.getNodeByKey("/help/PresentationsDocList");
        this.getChildTreeNodes(presentationsNode.key)
            .then(data => {
                presentationsNode.addChildren(data);
            });

        var odataNode = tree.getNodeByKey("/help/ODataDocs");
        this.getChildTreeNodes(odataNode.key)
            .then(data => {
                odataNode.addChildren(data);
            });

        var apiNode = tree.getNodeByKey("/help/APIDocs");
        this.getChildTreeNodes(apiNode.key)
            .then(data => {
                apiNode.addChildren(data);
            });

        // Get configuration tree node
        FetchWrapper.fetch("api/1.0/siteinfo/configurationname", { method: "get" })
            .then(response => response.json())
            .then((response: any) => {

                var configName = response.configurationName;

                var clientStuffNode = {
                    isFolder: true,
                    isExpanded: false,
                    title: configName,
                    key: "/help/ClientSpecificDocList",
                    extraClasses: "directoryfolder-node",
                    contentType: "pdfFileList"

                };

                var rootNode = tree.getRootNode();

                this.getChildTreeNodes(clientStuffNode.key)
                    .then(data => {
                        if (data.length > 0) {
                            rootNode.addNode(clientStuffNode);
                            var stuffNode = tree.getNodeByKey("/help/ClientSpecificDocList");
                            stuffNode.addChildren(data);
                        }

                    });

            });

        //var clientSpecificNode = tree.getNodeByKey("/help/ClientSpecificDocList");
        //getChildTreeNodes(clientSpecificNode.key)
        //    .then(function(data) {
        //        clientSpecificNode.addChildren(data);
        //    });

    }



    // Tree activate handler
    treeActivateHandler(event: JQueryEventObject, treeNode: Fancytree.EventData) {

        this.showVideo = false;


        if (!treeNode.node.hasChildren()) {
            const node = treeNode.node;
            const key = node.key;


            //alert(key);
            const title = node.title;

            if (key) {

                let url = "";
                const contentType = node.data.contentType;

                if (contentType === ".pdf") {
                    $("#contentDiv").hide();
                    $("#pdfDiv").show();
                } else {
                    $("#pdfDiv").hide();
                    $("#contentDiv").show();
                }

                if (contentType === "video" || contentType === ".webm" || contentType === ".mp4") {

                    //const source = encodeURIComponent(
                    //    //(fileUrlIncluded) ?
                    //    //"/api/1.0/" + node.key:
                    //    `/api/1.0/videos/${key}`);

                    this.videoModel = {
                        source: `/dist/Help/videos/${key}`,
                        title: title
                    }

                    this.showVideo = true;
                    return;


                    //                    url = `/Videos/Video?title=${title}&source=${source}`;
                } else if (contentType === "partialView") {
                    url = '@Url.Action("_tempKey_")'.replace("_tempKey_", key);
                } else if (contentType === ".pdf") {
                    $("#pdf-viewer").attr("data", key);
                    return;
                } else if (contentType === "pdfFileList") {

                } else
                    url = `/dist/Help/${key}`;


                FetchWrapper.fetch(url, { method: "get" })
                    .then(response => response.text())
                    .then(data => {

                        // Fix for image paths

                        const pathFixes = [
                            "User_Manual_Final_DMN_AC_files",
                            "EIA-MarketPowerNashCournotStackelbergOPEC-1_files",
                            "User_Manual_UI_files"
                        ];


                        pathFixes.forEach(fix => {
                            data = data.split(fix).join(`/dist/Help/${fix}`);
                        });

                        $("#contentDiv").html(data);
                    });

                //$.get(
                //        {
                //            url: url,
                //            global: false
                //        })
                //    .done((data: any) => {

                //        $('#contentDiv').html(data);

                //    });
            };
        }
    }


    populateTree(treeData) {
        $("#treeDiv").fancytree({
            activate: this.treeActivateHandler,
            deactivate: () => { },
            //  autoFocus: true,
            // autoCollapse: false,
            source: treeData

        });
    }

    getChildTreeNodes(key: string): Promise<any> {


        return FetchWrapper.fetch(key, { method: "get" })
            .then(response => response.json())
            .then((fileResult: any) => {
                var result = [];

                fileResult.forEach(file => {
                    var newNode: IDocInfo = {
                        title: file.description,
                        key: file.fileUrl,
                        contentType: file.contentType || ".pdf",
                        extraClasses: file.contentType === ".pdf" ? "pdf-node" : "video-node",
                        fileUrlIncluded: true
                    }
                    result.push(newNode);
                });
                return result;

            });

    }



}



// WEBPACK FOOTER //
// ./ClientApp/components/help/help-index.ts